import React, { useState } from "react";
import axios from "../../api/axiosInstance";
import useManagementDialog from "../../purchasing/hooks/useManagementDialog";
import { apiError } from "../../purchasing/utils/tenderManagement";

function Confirmation({ record, action, unit, onClose, onChanged }) {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const ref = useManagementDialog(onClose, busy);
  const label = action === "delete" ? "Delete" : action === "deactivate" ? "Deactivate" : "Activate";
  const submit = async () => {
    setBusy(true); setError("");
    try {
      const url = `/api/admin/purchasing/${unit ? "units" : "catalog"}/${record.id}`;
      if (action === "delete") await axios.delete(url);
      else if (unit) await axios.put(url, { is_active: action === "activate" });
      else await axios.patch(`${url}/state`, { is_active: action === "activate" });
      await onChanged(); onClose();
    } catch (failure) { setError(apiError(failure, "en")); } finally { setBusy(false); }
  };
  return <div className="pt-modal" role="dialog" aria-modal="true" aria-label={`${label} record`} tabIndex={-1} ref={ref}>
    <section className="pt-card"><h2>{label} {record.name}?</h2>
      <p>{action === "delete" ? "This permanently deletes the record. Records referenced by items, documents, tenders or business units cannot be deleted." : action === "deactivate" ? "The record will be kept and can be activated again. Active dependencies must be resolved first." : "The record will be available for selection again."}</p>
      {error && <div className="pt-notice pt-notice--error" role="alert">{error}</div>}
      <div className="pt-actions"><button type="button" disabled={busy} onClick={onClose}>Cancel</button><button type="button" className={action === "delete" ? "pt-danger" : "pt-primary"} disabled={busy} onClick={submit}>{busy ? "Saving…" : label}</button></div>
    </section>
  </div>;
}

export default function CatalogRecordActions({ record, unit = false, onChanged, disabled = false }) {
  const [action, setAction] = useState(null);
  return <>
    <button type="button" className="cp-text-button" disabled={disabled} aria-label={`${record.is_active === false ? "Activate" : "Deactivate"} ${record.name}`} onClick={() => setAction(record.is_active === false ? "activate" : "deactivate")}>{record.is_active === false ? "Activate" : "Deactivate"}</button>
    <button type="button" className="cp-text-button" disabled={disabled} aria-label={`Delete ${record.name}`} onClick={() => setAction("delete")}>Delete</button>
    {action && <div className="pt-shell cp-legacy-dialog"><Confirmation record={record} action={action} unit={unit} onClose={() => setAction(null)} onChanged={onChanged} /></div>}
  </>;
}
